import useSWR from 'swr'
import { useRouter } from 'next/router'
import { InnerLoader } from 'src/components/InnerLoader'
import { Widget } from 'src/components/Widget'
import { WIDGET_COINS_DEFAULT_CONFIG } from 'src/consts'
import { API_GET_MAPDATA } from 'src/consts'

export const CoinWidget = ({ slug }) => {
  const { query } = useRouter()
  const currencyQuery = query.primaryCurrency
    ? `?currency=${query.primaryCurrency}`
    : ''
  const fetcher = (...args) => fetch(...args).then(res => res.json())
  const { data } = useSWR(
    `${API_GET_MAPDATA}/${slug}/card${currencyQuery}`,
    fetcher,
    {
      refreshInterval: 10000,
    }
  )

  const config = {
    ...WIDGET_COINS_DEFAULT_CONFIG,
    ...query,
  }

  if (!data) return <InnerLoader />
  return (
    <Widget
      coinData={data}
      primaryCurrency={config.primaryCurrency}
      primaryTickerSymbol={config.primaryTickerSymbol === true}
      secondaryCurrency={config.secondaryCurrency}
      showRank={config.showRank === true}
      showMarketCap={config.showMarketCap === true}
      showVolume={config.showVolume === true}
      brightVersion={config.brightVersion}
    />
  )
}

export default CoinWidget
